var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutStock = function SvgOutStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    d: "m3.209.909 8.485 8.485-1.697 1.697-8.485-8.485z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    fillRule: "evenodd",
    d: "M11.694 2.606 3.21 11.091 1.512 9.394 9.997.91z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    d: "m3.209.909 8.485 8.485-1.697 1.697-8.485-8.485z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    d: "M11.694 2.606 3.21 11.091 1.512 9.394 9.997.91z",
    clipRule: "evenodd"
  })));
};
export { SvgOutStock as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvb3V0LXN0b2NrLmZmNzA1YzMxLnN2ZyI7";